import React from 'react';
import { Flex, HStack, Image, Text, Link } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';

import logo from '../../Resources/Images/Logos/logo.svg';

const BackStageNavbar: React.FC = () => {
  const location = useLocation();

  const navLinks = [
    { path: '/bs/stat-manager', text: '單位數量' },
    { path: '/bs/plan', text: '方案管理' },
    { path: '/bs/issuer', text: '機構管理' },
    { path: '/bs/statistic', text: '統計數據' },
    { path: '/bs/bulletin', text: '計畫公告' },
    { path: '/bs/document', text: '文件下載' },
  ];

  const isLinkActive = (path: string) => location.pathname.startsWith(path);

  return (
    <Flex
      as="header"
      position="sticky"
      top="0"
      zIndex="999"
      w="100%"
      h="88px"
      px={{ base: '16px', md: '24px', lg: '30px' }}
      py="23px"
      justify="space-between"
      align="center"
      bg="#FFFFFF"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <NavLink to="/bs/statistic" style={{ textDecoration: 'none' }}>
        <Flex align="center" gap="10px">
          <Image
            src={logo}
            alt="教育部電子證書驗證系統後台管理系統"
            h={{ base: '40px', md: '44px', lg: '48px' }}
            w="auto"
            objectFit="contain"
            display="block"
          />
          {(window as any).env.BETA && (
            <Text
              fontSize="14px"
              fontWeight="400"
              lineHeight="150%"
              letterSpacing="0.01em"
              color="#008DD4"
              whiteSpace="nowrap"
            >
              [測試版]
            </Text>
          )}
        </Flex>
      </NavLink>

      <HStack as="nav" spacing="22px">
        {navLinks.map((link) => {
          const active = isLinkActive(link.path);

          return (
            <NavLink key={link.path} to={link.path} style={{ textDecoration: 'none' }}>
              <Flex
                h="37px"
                px="12px"
                py="8px"
                align="center"
                justify="center"
                borderRadius="4px"
                bg={active ? '#008DD4' : '#00AAFF'}
                transition="background-color 0.2s ease"
                _hover={{
                  bg: active ? '#008DD4' : '#0099E6',
                }}
              >
                <Text
                  fontSize="14px"
                  fontWeight="400"
                  lineHeight="150%"
                  letterSpacing="0.01em"
                  color="#FFFFFF"
                  whiteSpace="nowrap"
                >
                  {link.text}
                </Text>
              </Flex>
            </NavLink>
          );
        })}

        <Link
          href={(window as any).env.MAIN_HOST + '/3ff4d155/'}
          _hover={{ textDecoration: 'none' }}
          onClick={() => sessionStorage.removeItem('bs_authed')}
        >
          <Flex
            h="37px"
            px="12px"
            py="8px"
            align="center"
            justify="center"
            borderRadius="4px"
            bg="#00AAFF"
            transition="background-color 0.2s ease"
            _hover={{
              bg: '#0099E6',
            }}
          >
            <Text
              fontSize="14px"
              fontWeight="400"
              lineHeight="150%"
              letterSpacing="0.01em"
              color="#FFFFFF"
              whiteSpace="nowrap"
            >
              登出
            </Text>
          </Flex>
        </Link>
      </HStack>
    </Flex>
  );
};

export default BackStageNavbar;
